import Head from '@/containers/chart_box/Head';
import Body from '@/containers/chart_box/Body';
import NumbersInfo from '../numbers_info/NumbersInfo';
import DormantMembers from '../numbers_info/DormantMembers';
import styles from './numberinfoList.less?modules';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { BrandContext } from '@/contexts/ContextProviders';
import { NumbersInfoListStyled } from './NumbersInfoListStyled';
import { isEmptyObject } from '@/utils/comUtil';
import { useIntl } from 'umi';
// import dayjs from 'dayjs';
import Divider from '@/assets/img/line.png';
import { mulTimeDimensionMulIndexSinValue } from '@/utils/reportResponseUtil';

const NumbersInfoList = (props) => {
  const { loading, data } = props;
  const intl = useIntl();
  const { formatMessage } = intl;
  const themeContext = useContext(ThemeContext);
  const brandContext = useContext(BrandContext);
  const result = mulTimeDimensionMulIndexSinValue(data || []);
  return (
    <NumbersInfoListStyled
      theme={themeContext}
      className={styles.box}
      brand={brandContext}
    >
      <Head boxId={'ec.dashboard.n01.lbl01'}>
        {/* <span className="updateTime">
          数据截止时间：{dayjs(data.updateDate).format('YYYY-MM-DD HH:mm')}
        </span> */}
      </Head>
      <Body bizData={data} loading={loading}>
        <div className="box-wapper">
          <div className={styles.box}>
            {!isEmptyObject(data) && (
              <div className={styles.r1}>
                <div className={styles.r1_c1} key={'NumbersInfo1'}>
                  <NumbersInfo
                    title={formatMessage({ id: 'ec.dashboard.n01.lbl02' })}
                    cycleList={[formatMessage({ id: 'comm.date.lbl.01' })]}
                    vipCount={result.ALL?.VIP_MEMBER?.VALUE}
                    count={result.ALL?.ALL_MEMBER?.VALUE}
                    day={result.DAY?.ALL_MEMBER?.VALUE}
                    dayRate={result.DAY?.ALL_MEMBER?.RATE}
                    week={result.WEEK?.ALL_MEMBER?.VALUE}
                    weekRate={result.WEEK?.ALL_MEMBER?.RATE}
                    month={result.MONTH?.ALL_MEMBER?.VALUE}
                    monthRate={result.MONTH?.ALL_MEMBER?.RATE}
                  />
                </div>
                {/* <span className={'divider'}></span> */}
                <img src={Divider} alt="" className={'divider'} />
                <div className={styles.r1_c2} key={'NumbersInfo2'}>
                  <NumbersInfo
                    title={formatMessage({ id: 'ec.dashboard.n01.lbl03' })}
                    cycleList={[formatMessage({ id: 'comm.date.lbl.01' })]}
                    vipCount={result.ALL?.VIP_ACTIVE_MEMBER?.VALUE}
                    count={result.ALL?.ACTIVE_MEMBER?.VALUE}
                    day={result.DAY?.ACTIVE_MEMBER?.VALUE}
                    dayRate={result.DAY?.ACTIVE_MEMBER?.RATE}
                    week={result.WEEK?.ACTIVE_MEMBER?.VALUE}
                    weekRate={result.WEEK?.ACTIVE_MEMBER?.RATE}
                    month={result.MONTH?.ACTIVE_MEMBER?.VALUE}
                    monthRate={result.MONTH?.ACTIVE_MEMBER?.RATE}
                  />
                </div>
                {/* <span className={'divider'}></span> */}
                <img src={Divider} className={'divider'} alt="" />
                <div className={styles.r1_c3} key={'NumbersInfo3'}>
                  <DormantMembers
                    title={formatMessage({ id: 'ec.dashboard.n01.lbl04' })}
                    cycleList={[formatMessage({ id: 'comm.date.lbl.01' })]}
                    vipCount={result.ALL?.VIP_DORMANT_MEMBER?.VALUE}
                    count={result.ALL?.DORMANT_MEMBER?.VALUE}
                    day={result.MONTH?.DORMANT_MEMBER?.VALUE}
                    hidden={true}
                    week={result.NINETY_DAY?.DORMANT_MEMBER?.VALUE}
                    month={result.HALF_YEAR?.DORMANT_MEMBER?.VALUE}
                    classname="dormancy-member"
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </Body>
    </NumbersInfoListStyled>
  );
};

export default NumbersInfoList;
